<template>
  <div
    :class="[
      $style['drawer-navigation'],
      { [$style['drawer-navigation--show-sub']]: subNavigation }
    ]">
    <div :class="$style['drawer-navigation__inner']">
      <div :class="$style['drawer-navigation__panel']">
        <LegacyDrawerList
          :items="mainNavigation.filter(item => item.valid)"
          @select="onSelect" />
      </div>
      <div :class="$style['drawer-navigation__panel']">
        <div v-if="subNavigation && subNavigation.length">
          <LegacyDrawerList
            :items="subNavigation.filter(item => item.valid)"
            show-back
            @back="subNavigation = null; $emit('showSubNavigation', false)" />
          <div :class="$style['drawer-navigation__panel__highlight-container']">
            <ToolbarHighlight
              v-for="item in highlights.filter(item => item.valid)"
              :key="item.id"
              :image="item.image"
              :aria-label="item.title"
              :to="`/${$lang}/${item.slugs[$lang]}`"
              :title="item.titles[$lang]"
              @click="closeDrawer" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
const emit = defineEmits(['showSubNavigation'])

const { closeDrawer } = useDrawer()
const { timedNavigation } = useTimedNavigation()
const subNavigation = ref(null)
const highlights = ref(null)

const mainNavigation = computed(() => {
  return timedNavigation({ filterByLocation: 'main' })
})

const onSelect = value => {
  subNavigation.value = value.subItems
  highlights.value = value.highlights
  emit('showSubNavigation', true)
}
</script>
<style lang="scss" module>
.drawer-navigation {
  .secondary {
    border-top: 1px solid var(--grey-lighter);
  }

  &__inner {
    display: flex;
    transition: transform var(--transition-time-in) var(--transition-ease-in);
    width: 200%;
  }

  &__panel {
    width: 100%;

    &__highlight-container {
      border-top: 1px solid var(--grey-lighter);
      display: flex;
      gap: var(--spacing);
      flex-direction: row;
      padding: calc(var(--spacing) * 2);
      width:100%;
      justify-content: flex-start;
    }
  }

  &--show-sub {
    min-height: 88vh;

    .drawer-navigation__inner {
      transform: translateX(-50%);
    }
  }
}
</style>
